import { useCallback, useEffect, useMemo, useState } from "react";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import CompanyApi from "../services/company.service";
import { SelectFPFormCompanyPropsType } from "./interface";

const SelectFPFormCompany = ({
    isDisabled,
    disableOptions,
    optionSelectedHandler,
    placeholder,
    migrationPlatform,
    selectedCompanyDetails,
}: SelectFPFormCompanyPropsType) => {
    const [companyList, setCompanyList] = useState<any>([]);
    const [selectedCompany, setSelectedCompany] = useState<any>(null);

    const apiservices = useMemo(() => new CompanyApi(), []);

    const onCompanySelect = useCallback(
        async (event: any, selectedCompanyDetails: any) => {
            if (selectedCompanyDetails) {
                const supportUser: any =
                    (await apiservices.getSupportUserForCompany(
                        selectedCompanyDetails.value,
                        migrationPlatform
                    )) || {};
                console.log(supportUser);

                await localStorage.setItem(
                    "selectedCompanyDisplay",
                    selectedCompanyDetails.title
                );
                await localStorage.setItem("selectedCompanyId", selectedCompanyDetails.value);
                await localStorage.setItem(
                    "supportUserIdOfSelectedCompany",
                    supportUser.id
                );
                const googleTokenId = localStorage.getItem("google-token");
                const selectedCompanyId =
                    localStorage.getItem("selectedCompanyId");
                const params = {
                    googleTokenId: googleTokenId,
                    selectedCompanyId: selectedCompanyId,
                    supportUserId: supportUser.id,
                };
                const response = await apiservices.auth(
                    params,
                    migrationPlatform
                );
                await localStorage.setItem(
                    "access-token",
                    response.accessToken
                );
                await localStorage.setItem("company-id", selectedCompanyDetails.value);
                await localStorage.setItem("user-id", supportUser.id);
                setSelectedCompany({
                    title: selectedCompanyDetails.title,
                    value: selectedCompanyDetails.value,
                });
            }
        },
        [apiservices, migrationPlatform]
    );

    const getCompanyList = useCallback(async () => {
        let response: any[] =
            (await apiservices.getCompanies(migrationPlatform)) || [];
        var companyList: any = [];
        if (!Array.isArray(response)) response = [];
        response.forEach((company: any) => {
            companyList.push({
                title: `${company.name} (${company.id})`,
                value: company.id,
            });
        });
        var resultArray = Object.keys(companyList).map(function (compIndex) {
            let company = companyList[compIndex];
            return company;
        });
        setCompanyList(resultArray);
        try {
            await onCompanySelect("", selectedCompany);
        } catch (error) {
            console.error(error);
        }
    }, [apiservices, onCompanySelect, migrationPlatform]);

    useEffect(() => {
        getCompanyList();
    }, [migrationPlatform]);

    useEffect(() => {
        if (selectedCompany && selectedCompany !== selectedCompanyDetails)
            optionSelectedHandler(selectedCompany);
    }, [selectedCompany, optionSelectedHandler]);

    useEffect(() => {
        if (!selectedCompanyDetails) setSelectedCompany(null);
    }, [selectedCompanyDetails]);

    return (
        <Autocomplete
            options={companyList}
            getOptionLabel={(option: any) => option.title}
            getOptionSelected={(option, value) => option.title === value.title}
            onChange={async (event, value) => {
                try {
                    await onCompanySelect(event, value);
                } catch (error) {
                    console.error(error);
                }
            }}
            getOptionDisabled={(option) =>
                isDisabled || disableOptions?.value === option.value
            }
            value={selectedCompany || { title: "" }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={placeholder || "Source Company"}
                    variant="outlined"
                    label={placeholder || "Source Company"}
                />
            )}
        />
    );
};

export default SelectFPFormCompany;
